const STACK_CATEGORY_KOR_MAP = new Map();

STACK_CATEGORY_KOR_MAP.set('lang', '언어');
STACK_CATEGORY_KOR_MAP.set('frontend', '프론트엔드');
STACK_CATEGORY_KOR_MAP.set('mobile', '모바일');
STACK_CATEGORY_KOR_MAP.set('backend', '백엔드');
STACK_CATEGORY_KOR_MAP.set('cloud', '클라우드');
STACK_CATEGORY_KOR_MAP.set('devops', '데브옵스');
STACK_CATEGORY_KOR_MAP.set('db', '데이터베이스');
STACK_CATEGORY_KOR_MAP.set('data', '데이터');
STACK_CATEGORY_KOR_MAP.set('os', 'OS');
STACK_CATEGORY_KOR_MAP.set('domain', '기술 및 도메인');
STACK_CATEGORY_KOR_MAP.set('test', '테스트');
STACK_CATEGORY_KOR_MAP.set('solution', '솔루션');
STACK_CATEGORY_KOR_MAP.set('etc', '기타');

const STACK_CATEGORY_ICONS = {
  lang: '🧑‍💻',
  frontend: '🖥️',
  mobile: '📱',
  backend: '🗄️',
  cloud: '☁️',
  devops: '🧰',
  db: '🗂️',
  data: '🗃️',
  os: '⚙️️',
  domain: '🛠️',
  test: '🧪',
  solution: '💡',
  etc: '🔧',
};

export { STACK_CATEGORY_KOR_MAP, STACK_CATEGORY_ICONS };
